export default [{
  "access_denied_title": "Accesso non abilitato",
  "access_denied_label": "Non si è abilitati all'accesso alla piattaforma utilizzando queste credenziali",
  "access_denied_contact_administrators": "Contattare il proprio amministratore di sistema per ulteriori informazioni",
}]